module.exports = __webpack_public_path__ + "static/media/sygnet.b191199c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/sygnet.svg
// module id = 1495
// module chunks = 2